import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import brandingConfig from '../../config/brandingConfig';

const MobileAppQRDialog = ({ open, onClose, url }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>QR-Code zur Mobile App</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
          <QRCodeSVG value={url} size={220} level="H" />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            Scannen Sie den QR-Code, um die <strong>{brandingConfig.appName}</strong> App herunterzuladen.
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            {url}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MobileAppQRDialog;
